import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import { CircularProgress, IconButton, InputBase, Paper } from "@mui/material";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import { CloseOutlined, KeyboardArrowLeft } from "@mui/icons-material";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import SearchIcon from "@mui/icons-material/Search";
import Button from "../../Components/Button";
import Clinics from "./Clinics";
import ErrorComponent from "../../Components/ErrorComponent";

function ReqMedical4() {
  const {
    setSelectedProcedureClass,
    setSearchBranchResults,
    selectedProcedureClass,
    setSelectedProcedures,
    selectedProcedures,
    availableClinics,
    setDisplayAlert,
    setSearchBranch,
    selectedClinic,
    searchBranch,
    getProviders,
    handleBack,
    isLoading,
    loadState,
    navigate,
    files,
  } = useRequestMedicalContext();

  const stepFourValidation = selectedClinic !== undefined;

  const handleNext = () => {
    if (stepFourValidation) {
      //thru file upload
      if (files.length > 0) {
        const updatedProcedures = selectedProcedureClass.map(
          ({ date, time, ...rest }) => rest
        );
        setSelectedProcedureClass(updatedProcedures);
      }
      //thru emed
      else {
        const updatedProcedures = selectedProcedures.map(
          ({ date, time, ...rest }) => rest
        );
        setSelectedProcedures(updatedProcedures);
      }
      navigate("/request-medical-test/choose-date-time");
    }
  };

  const ScrollBar = () => {
    return (
      <>
        <ScrollArea.Scrollbar
          className="flex select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-gray-100 data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
          orientation="vertical"
        >
          <ScrollArea.Thumb className="flex-1 bg-gray-600 rounded-[10px] relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
        </ScrollArea.Scrollbar>
        <ScrollArea.Scrollbar
          className="flex select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-gray-100 data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
          orientation="horizontal"
        >
          <ScrollArea.Thumb className="flex-1 bg-gray-600 rounded-[10px] relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
        </ScrollArea.Scrollbar>
        <ScrollArea.Corner className="bg-gray-600" />
      </>
    );
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchBranch(value);
    const filteredData = availableClinics.filter(
      (data) =>
        data.providerName.toLowerCase().includes(value.toLowerCase()) ||
        data.address.toLowerCase().includes(value.toLowerCase())
    );
    setSearchBranchResults(filteredData);
  };

  let content = null;
  if (loadState === "get providers") {
    content = (
      <div className="w-full flex justify-center items-center mt-4">
        <CircularProgress />
      </div>
    );
  } else if (
    ["get providers ISE", "get providers retry", "get providers timeout"]
    .includes(loadState)
  ) {
    content = (
      <ErrorComponent
        onRetry={() => getProviders("get providers retry")}
        isLoading={loadState === "get providers retry"}
      />
    );
  } else {
    content = <Clinics/>
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Request Medical Test
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={57.12} />
          </div>
        </div>

        <div className="w-full px-3">
          <div className="text-sm text-[#60656D]">
            Find Primary Care Clinics or cities near you
          </div>
          <Paper
            component="form"
            sx={{
              width: "100%",
              mt: 2,
              mb: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton disabled aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search clinic or city"
              value={searchBranch}
              onChange={handleSearch}
              inputProps={{ "aria-label": "search google maps" }}
            />
          </Paper>
          <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
            <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-263px)] sm:h-full sm:max-h-[400px] rounded">
              {content}
            </ScrollArea.Viewport>
            <ScrollBar />
          </ScrollArea.Root>
        </div>
        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={!stepFourValidation || isLoading}
            className={`h-14 w-full sm:w-22.5 rounded-xl ${
              !stepFourValidation ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            }`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepFourValidation || isLoading
                  ? "text-[#A3A7AB]"
                  : "text-white"
              }`}
            >
              Continue
            </p>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReqMedical4;
